import { forwardRef } from 'react'

import clsx from 'clsx'
import { RemixiconReactIconComponentType } from 'remixicon-react'

import { Button, ButtonProps } from '@tribeplatform/react-ui-kit/Button'

type ComposerIconButtonProps = ButtonProps & {
  icon: RemixiconReactIconComponentType
}

/**
 * Square button that contains only an icon
 */
export const ComposerIconButton = forwardRef<
  HTMLButtonElement,
  ComposerIconButtonProps
>(({ icon: Icon, className, size = 'lg', ...props }, ref) => (
  <Button
    ref={ref}
    size={size}
    variant="outline"
    leadingIcon={<Icon />}
    className={clsx('rounded-md', className)}
    {...props}
  />
))
